import {
  IAMAccountEntity,
  IAMAccountEntityRaw
} from "@youm-front/iam-account/domain";

export function buildIAMAccountEntity(
  iamAccountEntityRaw: IAMAccountEntityRaw
): IAMAccountEntity {
  return new IAMAccountEntity(iamAccountEntityRaw);
}
